import React from "react";
import ImageSlideshow from "../ImageSlideshow";
import "./styles/atoms.css";
import "./styles/IntroSplit.css";

/**
 * The image + text intro block used on 11 pages.
 *
 * Handles every image variant the old pages had:
 *   image={heroImage}            → single <img>
 *   images={heroImages}          → ImageSlideshow
 *   media={<iframe … />}         → anything custom (Anfahrt's map)
 *
 * Text is equally flexible: pass `text` as a string, an array of
 * strings (Welt's two paragraphs), or children for full control.
 *
 * <IntroSplit
 *   images={heroImages}
 *   kicker={introKicker}
 *   title={introTitle}
 *   text={introText}
 *   mediaSide="left"
 * />
 */
export default function IntroSplit({
  image,
  images,
  media,
  alt,
  kicker,
  title,
  text,
  children,
  mediaSide = "left",
  after,
}) {
  const paragraphs = Array.isArray(text) ? text.filter(Boolean) : text ? [text] : [];

  let mediaNode = media || null;

  if (!mediaNode && images?.length) {
    mediaNode = <ImageSlideshow images={images} rounded={false} />;
  }

  if (!mediaNode && image?.url) {
    mediaNode = <img src={image.url} alt={image.alt || alt || title || ""} />;
  }

  return (
    <div className={`rs-split ${mediaSide === "right" ? "rs-split--media-right" : ""}`}>
      {mediaNode && <figure className="rs-split__media">{mediaNode}</figure>}

      <div className="rs-split__text">
        {kicker && <p className="rs-kicker">{kicker}</p>}
        {title && <h2>{title}</h2>}
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
        {children}
        {after}
      </div>
    </div>
  );
}